// The voice's volume, applied to a whole line before it plays. Above 1, a limiter holds the peaks under the ceiling,
// so a voice raised over loud music gets louder without clipping. It sees the whole line, so it eases into each peak
// ahead of time (attack) and lets go after it (release), instead of squashing single samples.
const CEILING = 0.95;
const ATTACK_SECONDS = 0.005;
const RELEASE_SECONDS = 0.08;

export const withGain = (pcm, gain, sampleRate) => {
  const out = new Float32Array(pcm.length);
  if (gain <= 1) {
    for (let i = 0; i < pcm.length; i += 1) out[i] = pcm[i] * gain;
    return out;
  }

  // How much of the gain each sample can take and stay under the ceiling
  const allowed = new Float32Array(pcm.length);
  for (let i = 0; i < pcm.length; i += 1) {
    const level = Math.abs(pcm[i]) * gain;
    allowed[i] = level > CEILING ? CEILING / level : 1;
  }
  const attackStep = 1 / (ATTACK_SECONDS * sampleRate);
  for (let i = pcm.length - 2; i >= 0; i -= 1) allowed[i] = Math.min(allowed[i], allowed[i + 1] + attackStep);

  const releaseStep = 1 / (RELEASE_SECONDS * sampleRate);
  let reduction = 1;
  for (let i = 0; i < pcm.length; i += 1) {
    reduction = Math.min(allowed[i], reduction + releaseStep);
    out[i] = pcm[i] * gain * reduction;
  }
  return out;
};
